import { render, staticRenderFns } from "./EformElementEditFile.vue?vue&type=template&id=4ced6def&scoped=true&"
import script from "./EformElementEditFile.vue?vue&type=script&lang=js&"
export * from "./EformElementEditFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced6def",
  null
  
)

export default component.exports